/**
 * Utility for browser whitelisting
 * @class BrowsersWhitelist
 */


 let BrowsersWhitelist = {
	// VARIABILI STATICHE
	Browser: null,
	Version: 0,
	Support: 0,
	IsMobile: false,
	IsTablet: false,
	IsDesktop: false,
	IsApp: false,

	// ENUMS
	SupportTypes:
	{
		NONE: 0,
		PARTIAL: 1,
		FULL: 2
	},

	FullSupportProps: ["getusermedia", "peerconnection", "websockets", "flexbox", "flexboxlegacy"],
	PartialSupportProps: ["websockets", "flexbox", "flexboxlegacy"],

	FormFactors:
	{
		DESKTOP: "desktop",
		MOBILE: "mobile",
		TABLET: "tablet"
	},

	DeviceType:
	{
		IPHONE: "iPhone",
		IPAD: "iPad",
		ANDROID: "Android",
		ALL: ""
	},

    /**
     * Initialize the script
     * @function
     */
	GetBroswerProps: function () {
		let support = BrowsersWhitelist.GetSupport();
		let browserInfos = BrowsersWhitelist.GetBrowserInfo();
		let formFactor = BrowsersWhitelist.GetFormFactor();
		let deviceType = BrowsersWhitelist.GetDeviceType();

		// Setto le variabili statiche
		BrowsersWhitelist.Browser = browserInfos.Browser;
		BrowsersWhitelist.Version = browserInfos.Version;
		BrowsersWhitelist.Support = support;

		BrowsersWhitelist.IsMobile = formFactor == BrowsersWhitelist.FormFactors.MOBILE;
		BrowsersWhitelist.IsTablet = formFactor == BrowsersWhitelist.FormFactors.TABLET;
		BrowsersWhitelist.IsDesktop = formFactor == BrowsersWhitelist.FormFactors.DESKTOP;
		BrowsersWhitelist.IsApp = browserInfos.Browser == "CAMTVAPP";
	},

    /**
     * Return FULL, PARTIAL, or NONE depending if the feature is supported or not
     * @function
     */
	GetSupport: function () {
		// VALUTAZIONE DEFINITA SULLE PROPRIETÀ DI MODERNIZR
		let support = BrowsersWhitelist.SupportTypes.FULL;

		// Se non soddisfa tutte le proprietà del FULL support allora lo declassa a PARTIAL
		/*for (let index in BrowsersWhitelist.FullSupportProps) {
			let sPropName = BrowsersWhitelist.FullSupportProps[index];
			if (Modernizr[sPropName] == false) {
				console.warn("Unsupported feature: " + sPropName);
				support = BrowsersWhitelist.SupportTypes.PARTIAL;
				break;
			}
		};

		// Se non soddisfa tutte le proprietà del PARTIAL support allora lo declassa a NONE
		for (let index in BrowsersWhitelist.PartialSupportProps) {
			let sPropName = BrowsersWhitelist.PartialSupportProps[index];
			if (Modernizr[sPropName] == false) {
				console.warn("Unsupported feature: " + sPropName);
				support = BrowsersWhitelist.SupportTypes.NONE;
				break;
			}
		};*/

		support = BrowsersWhitelist._CheckCustomRulesSupport(support);

		return support;
	},

	_CheckCustomRulesSupport: function (support) {
		let browserInfos = BrowsersWhitelist.GetBrowserInfo();
		let deviceType = BrowsersWhitelist.GetDeviceType();

		// Imposto il supporto parziale agli iPhone e iPad, e definisco il supporto parziale su safari
		if (support > BrowsersWhitelist.SupportTypes.NONE || support == null) {
			if (browserInfos.Browser == "SAFARI" || deviceType == BrowsersWhitelist.DeviceType.IPHONE || deviceType == BrowsersWhitelist.DeviceType.IPAD)
				return BrowsersWhitelist.SupportTypes.PARTIAL;

			if (browserInfos.Browser == "EDGE")
				return BrowsersWhitelist.SupportTypes.PARTIAL;

			if (browserInfos.Browser == "FBAPP")
				return BrowsersWhitelist.SupportTypes.PARTIAL;
		}

		return support;
    },
    
    /**
     * Returns the browser info
     * @function
     * @param {String} sUserAgent - User agent
     */
	GetBrowserInfo: function (sUserAgent) {
		let ua = sUserAgent ? sUserAgent : navigator.userAgent;
		let result = {};
		result.Browser = "";
		result.Version = 0;

		for (let i in BrowsersWhitelist.Regexes.Browsers) {
			let element = BrowsersWhitelist.Regexes.Browsers[i];

			for (let j in element[0]) {
				let regex = element[0][j];
				let M = ua.match(regex);

				if (M != null) {
					result.Browser = element[1];

					if (result.Browser == "CAMTVAPP")
						result.Version = 0;
					else if (result.Browser == "SAFARI" || result.Browser == "FBAPP")
						result.Version = parseInt(M[1]);
					else
						result.Version = parseInt(M[2]);
					break;
				}
			}

			if (result.Browser != "")
				break;
		}
		return result;
	},

	GetFormFactor: function (sUserAgent) {
		let ua = sUserAgent ? sUserAgent : navigator.userAgent;

		if (ua.match(/iPad/i) || (ua.match(/Android/i) && !ua.match(/Mobile/i)))
			return BrowsersWhitelist.FormFactors.TABLET;

		else if (ua.match(/Android|BlackBerry|iPhone|iPod|Opera Mini|IEMobile/i) || ua.match(/Mobile/i))
			return BrowsersWhitelist.FormFactors.MOBILE;

		else
			return BrowsersWhitelist.FormFactors.DESKTOP;
	},

    /**
     * Returns the device type
     * @function
     * @param {String} sUserAgent - User agent
     */
	GetDeviceType: function (sUserAgent) {
		let ua = sUserAgent ? sUserAgent : navigator.userAgent;

		//Android o iOS
		if (ua.match(/iPhone/i) || ua.match(/iPad/i)) {
			return BrowsersWhitelist.DeviceType.IPHONE;
		}
		else if (ua.match(/iPad/i)) {
			return BrowsersWhitelist.DeviceType.IPAD;
		}
		else if (ua.match(/Android/i)) {
			return BrowsersWhitelist.DeviceType.ANDROID;
		}
		else
			return BrowsersWhitelist.DeviceType.ALL;
	},

	Regexes: {
		// Si definiscono uan serie di stringhe di regex (per le varie versioni di un browser ed il nome da associare
		Browsers: [
			// APP CAMTV
			[[
				/CamTVApp/i
			], "CAMTVAPP"],

			// OTHER
			[[
				/(micromessenger)\/([\w\.]+)/i,                                     // WeChat
				/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i, // Google Search Appliance on iOS
			], "OTHER"],

			// CRAWLER
			[[
				/(Bot|bot)\/?\s*(\d+)/i,
			], "CRAWLER"],

			// Facebook App for iOS & Android
			[[
				/FBOP\/([\w\.]+);/i,
				/FBAN\/([\w\.]+);/i,
				/;fbav\/([\w\.]+);/i
			], "FBAPP"],

			// OPERA
			[[
				/(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
				/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
				/(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
				/(opera)[\/\s]+([\w\.]+)/i,                                         // Opera < 9.80
				/\s(opr)\/([\w\.]+)/i,                                              // Opera Webkit
				/(opios)[\/\s]+([\w\.]+)/i                                         // Opera mini on iphone >= 8.0
			], "OPERA"],

			// ORCA/AVANT
			[[
				/(Orca)\/([\w\.-]+)$/i,
				/(Avant)\/([\w\.]+).+rv\:.+gecko\/\d+/i,
			], "ORCA/AVANT"],

			// FIREFOX
			[[
				/fxios\/([\w\.-]+)/i,                                               // Firefox for iOS
				/(firefox)\/([\w\.-]+)$/i,
				/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
			], "FIREFOX"],

			// EDGE
			[[
				/(edge)\/((\d+)?[\w\.]+)/i,
			], "EDGE"],

			// IE11
			[[
				/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i,
				/(?:ms|\()(ie)\s([\w\.]+)/i,
			], "IE"],

			// CHROME
			[[
				/(chrome|trident(?=\/))\/?\s*(\d+)/i,								// Chrome
				/\swv\).+(chrome)\/([\w\.]+)/i,                                     // Chrome WebView
				/((?:android.+)crmo|crios)\/([\w\.]+)/i,                            // Chrome for Android/iOS
			], "CHROME"],

			// ANDROID BROWSER
			[[
				/xiaomi\/miuibrowser\/([\w\.]+)/i,                                  // MIUI Browser
				/((?:oculus|samsung)browser)\/([\w\.]+)/i,							// Oculus / Samsung Browser
				/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i,       // Android Browser
			], "CHROME"],

			// SAFARI LASCIARLO PER ULTIMO!!!
			[[
				/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i,                      // Mobile Safari
				/version\/([\w\.]+).+?(mobile\s?safari|safari)/i,                   // Safari & Safari Mobile
				/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i,                    // Safari < 3.0
			], "SAFARI"],
		]
	}
};

export default BrowsersWhitelist;